import { Box } from '@mui/material'
import ProgramPageHero from '../programs/ProgramPageHero'
import ProgramWhySection from '../programs/ProgramWhySection'
import ProgramSkillsSection from '../programs/ProgramSkillsSection'
import ProgramStatsSection from '../programs/ProgramStatsSection'
import ProgramTestimonialsSection from '../programs/ProgramTestimonialsSection'
import ProgramGallerySection from '../programs/ProgramGallerySection'
import DimensionHeroImage from './DimensionHeroImage'
import DimensionSplitSection from './DimensionSplitSection'
import DimensionInitiativesSection from './DimensionInitiativesSection'
import { homeTestimonials } from '../../data/homeContent'
import { programSectionWrapperSx, programInnerSx, programSectionGap } from '../programs/programLayout'
import { mobileSectionPy } from '../../theme/mobileLayout'

export default function DimensionPageTemplate({ data }) {
  if (!data) return null

  return (
    <Box>
      <Box
        sx={{
          ...programSectionWrapperSx,
          pt: { ...mobileSectionPy, md: '120px', lg: '260px' },
          pb: mobileSectionPy,
        }}
      >
        <ProgramPageHero title={data.title} subtitle={data.subtitle} />
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: programSectionGap,
          pb: { xs: 8, md: 12, lg: '150px' },
        }}
      >
        <Box sx={programSectionWrapperSx}>
          <Box
            sx={{
              ...programInnerSx,
              display: 'flex',
              flexDirection: 'column',
              gap: { xs: 5, md: '80px' },
            }}
          >
            <DimensionHeroImage src={data.heroImage} alt={data.title} />

            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: 5, md: '80px' },
              }}
            >
              <DimensionSplitSection title={data.aboutTitle} paragraphs={data.aboutParagraphs} />

              {data.mission && (
                <DimensionSplitSection title="Our Mission" paragraphs={[data.mission]} />
              )}

              <DimensionInitiativesSection initiatives={data.initiatives} />

              {data.whyTitle && data.whyItems?.length > 0 && (
                <ProgramWhySection
                  title={data.whyTitle}
                  items={data.whyItems}
                  starSrc={data.whyStarIcon}
                  titleMaxWidth={{ md: 320, lg: 520 }}
                />
              )}
            </Box>
          </Box>
        </Box>

        <Box sx={programSectionWrapperSx}>
          <Box
            sx={{
              ...programInnerSx,
              display: 'flex',
              flexDirection: 'column',
              gap: programSectionGap,
            }}
          >
            {data.skills?.length > 0 && (
              <ProgramSkillsSection title={data.skillsTitle ?? 'Key Focus Areas'} skills={data.skills} />
            )}

            {data.stats?.length > 0 && (
              <ProgramStatsSection title={data.statsTitle ?? 'Empowering Students For Success'} stats={data.stats} />
            )}
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 5, md: '80px' },
          }}
        >
          <ProgramTestimonialsSection
            testimonials={data.testimonials ?? homeTestimonials}
            compactBottom
          />

          {data.galleryImages?.length > 0 && (
            <Box sx={programSectionWrapperSx}>
              <Box sx={programInnerSx}>
                <ProgramGallerySection
                  title={data.galleryTitle ?? 'Gallery'}
                  images={data.galleryImages}
                  alwaysShowLoadMore
                />
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  )
}
